import React from "react";
import { Star, Check, ArrowRight } from "lucide-react";

export default function About({ brand, stats, about, onBook }) {
  const offers = about?.offers || [];
  const paragraphs = about?.paragraphs || [];
  const coachImg = brand?.coach_image || "https://images.pexels.com/photos/6321605/pexels-photo-6321605.jpeg";

  return (
    <section id="about" className="py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-5 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
        <div className="md:col-span-6 relative">
          <div className="relative" style={{ aspectRatio: "4/5" }}>
            {/* Arched frame */}
            <div className="absolute inset-0 overflow-hidden"
                 style={{ borderTopLeftRadius: "50% 30%", borderTopRightRadius: "50% 30%", borderBottomLeftRadius: "20px", borderBottomRightRadius: "20px" }}>
              <img src={coachImg} alt={brand?.coach || "Prriyanka Dora"} className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="absolute -bottom-4 right-4 md:right-6">
            <div className="ev-pill !py-3 !px-4 flex flex-col items-start">
              <div className="flex" style={{ color: "var(--ev-blue-2)" }}>
                {[0,1,2,3,4].map((i) => (<Star key={i} className="w-4 h-4 fill-current" />))}
              </div>
              <span className="eyebrow !text-[10px] mt-2">Loved by {stats?.loved_by || "1,000"} souls</span>
            </div>
          </div>
        </div>

        <div className="md:col-span-6">
          <div className="eyebrow">Know about your coach</div>
          <h2 className="font-serif-ev mt-4 text-5xl md:text-6xl leading-[1.02] tracking-tight">
            {brand?.coach || "Prriyanka Dora"}
          </h2>
          <div className="mt-3 text-lg" style={{ color: "var(--ev-blue-2)" }}>
            {brand?.title || "Healing & Manifestation Coach · Certified NLP Practitioner"}
          </div>
          <div className="mt-8 space-y-5 text-[15px] md:text-base leading-relaxed" style={{ color: "var(--ev-muted)" }}>
            {paragraphs.map((p, i) => (<p key={i}>{p}</p>))}
          </div>

          <div className="mt-10">
            <div className="eyebrow">What she offers</div>
            <ul className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {offers.map((o) => (
                <li key={o} className="flex items-start gap-3">
                  <span className="mt-0.5 w-5 h-5 rounded-full grid place-items-center flex-shrink-0" style={{ background: "var(--ev-blue-2)" }}>
                    <Check className="w-3 h-3 text-white" />
                  </span>
                  <span className="text-[15px]" style={{ color: "var(--ev-ink-2)" }}>{o}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-8">
            <button onClick={onBook} className="ev-btn ev-btn-primary">
              Work with Prriyanka <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
